(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-rewards-progress"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('product-rewards-progress')) return;
  class ProductRewardsProgress extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.promptSignature = null;
      this.config = JSON.parse(this.querySelector('[data-pr-config]').textContent);
      this.scope = this.closest('.product__info-wrapper') || this.closest('product-info') || this.closest('.product__info-container');
      if (!this.scope) { this.hidden = true; return; }
      this.scheduleSync = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.syncPrice();
        });
      };
      this.onSelection = () => {
        this.bundleEvent = null;
        this.scheduleSync();
      };
      this.onBundlePrice = event => {
        if (event.currentTarget !== this.widget) return;
        const amount = event.detail?.pricing?.discountedPrice?.amount;
        this.bundleEvent = Number.isSafeInteger(amount) && amount >= 0
          ? {amount, valid:event.detail?.validation?.allItemsSelected !== false, fresh:true}
          : null;
        this.scheduleSync();
      };
      this.onChange = event => {
        if (this.widget?.contains(event.target)) this.bundleEvent = null;
        this.scheduleSync();
      };
      this.readKachingPrice = () => {
        const widget = this.scope.querySelector('kaching-bundles-block');
        if (!widget) return null;
        let config;
        try { config = JSON.parse(widget.getAttribute('config') || '{}'); } catch { return null; }
        if (config.marketCurrencyCode !== this.config.currency || this.config.currency !== 'USD') return null;
        const bars = Array.from(widget.querySelectorAll('.kaching-bundles__bar--selected'));
        if (!bars.some(bar => bar.hasAttribute('data-deal-bar-id'))) return null;
        let total = 0;
        for (const bar of bars) {
          const text = bar.querySelector('.kaching-bundles__bar-pricing > .kaching-bundles__bar-price')?.textContent?.trim();
          const match = text?.match(/^(?:US)?\$\s*([\d,]+(?:\.\d{1,2})?)$/);
          if (!match) return null;
          total += Math.round(Number(match[1].replaceAll(',','')) * 100);
        }
        return Number.isSafeInteger(total) ? total : null;
      };
      this.syncPrice = () => {
        this.bindWidget();
        const signature = this.widgetSignature();
        if (this.bundleEvent && this.widgetCurrencyMatches()) {
          if (this.bundleEvent.fresh || this.bundleEvent.signature === signature) {
            this.bundleEvent.fresh = false;
            this.bundleEvent.signature = signature;
            this.dataset.priceSource = 'kaching-event';
            this.update(this.bundleEvent.amount, this.bundleEvent.valid);
            return;
          }
        }
        this.bundleEvent = null;
        const bundlePrice = this.readKachingPrice();
        if (bundlePrice !== null) {
          this.dataset.priceSource = 'kaching';
          this.update(bundlePrice, true);
          return;
        }
        this.dataset.priceSource = 'variant';
        const variant = this.readNativeVariant();
        this.update(variant?.price, !!variant);
      };
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.scheduleSync();
      });
      this.observer.observe(this.scope, {subtree:true,childList:true,attributes:true,characterData:true,attributeFilter:['data-price','data-valid','class','hidden','config','aria-checked','value']});
      this.scope.addEventListener('change',this.onChange,true);
      this.syncPrice();
    }
    readNativeVariant() {
      const variants = this.config.variants || [];
      const picker = this.scope.querySelector('variant-selects,variant-radios');
      if (picker) {
        const fields = Array.from(picker.querySelectorAll('fieldset'));
        const options = fields.length
          ? fields.map(field => field.querySelector('input:checked')?.value)
          : Array.from(picker.querySelectorAll('select')).map(select => select.value);
        if (options.length) {
          return variants.find(variant => variant.options.length === options.length &&
            variant.options.every((value,index) => value === options[index])) || null;
        }
      }
      const input = this.scope.querySelector('[id="product-form-' + this.dataset.sectionId + '"] [name="id"]') ||
        this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
      const id = input ? input.value : this.config.variantId;
      return variants.find(variant => String(variant.id) === String(id)) || null;
    }
    bindWidget() {
      const widget = this.scope.querySelector('kaching-bundles-block');
      if (widget === this.widget) return;
      this.unbindWidget();
      this.widget = widget;
      widget?.addEventListener('variants-changed',this.onBundlePrice);
      widget?.addEventListener('deal-bar-selected',this.onSelection);
      widget?.addEventListener('variant-selected',this.onSelection);
    }
    unbindWidget() {
      this.widget?.removeEventListener('variants-changed',this.onBundlePrice);
      this.widget?.removeEventListener('deal-bar-selected',this.onSelection);
      this.widget?.removeEventListener('variant-selected',this.onSelection);
      this.widget = null;
      this.bundleEvent = null;
    }
    widgetCurrencyMatches() {
      try { return JSON.parse(this.widget?.getAttribute('config') || '{}').marketCurrencyCode === this.config.currency; }
      catch { return false; }
    }
    widgetSignature() {
      if (!this.widget) return '';
      return JSON.stringify([
        this.widget.getAttribute('config'),
        Array.from(this.widget.querySelectorAll('.kaching-bundles__bar--selected')).map(bar => [
          bar.getAttribute('data-deal-bar-id'),
          bar.querySelector('.kaching-bundles__bar-pricing > .kaching-bundles__bar-price')?.textContent,
          Array.from(bar.querySelectorAll('select,input')).map(input => [input.value,input.checked])
        ])
      ]);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.scope?.removeEventListener('change',this.onChange,true);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.unbindWidget();
    }
    update(price, valid) {
      const config = this.config;
      const thresholds = config.thresholds;
      if (!thresholds.every((value,index) => value > 0 && (!index || value > thresholds[index - 1]))) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      const amount = Number(price);
      if (!valid || !Number.isFinite(amount) || amount < 0) { this.hidden = true; return; }
      const stage = thresholds.filter(value => amount >= value).length;
      const target = thresholds[Math.min(stage,2)];
      const start = stage === 0 ? 0 : thresholds[Math.min(stage,2) - 1];
      const progress = stage === 3 ? 100 : Math.max(0, Math.min(100, (amount - start) / (target - start) * 100));
      const currency = config.currency;
      const formatMoney = value => currency === 'USD'
        ? '$' + new Intl.NumberFormat('en-US', {maximumFractionDigits:2}).format(value / 100)
        : new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(value / 100);
      const money = formatMoney(Math.max(0,target - amount));
      this.querySelector('.pr-progress__start').textContent = formatMoney(start);
      this.querySelector('.pr-progress__end').textContent = formatMoney(target);
      const reward = this.querySelector('.pr-progress__reward');
      const prompt = this.querySelector('.pr-progress__prompt');
      this.dataset.stage = String(stage);
      this.style.setProperty('--pr-fill', `${progress}%`);
      this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.round(progress)));
      const rewardText = stage === 0 ? '' : config.rewards[stage] || '';
      const rewardLabel = this.querySelector('.pr-progress__reward-text');
      const template = config.prompts[stage] || '';
      const offer = config.offers?.[stage] || '';
      const signature = JSON.stringify([template,money,offer]);
      if (rewardLabel.textContent !== rewardText) rewardLabel.textContent = rewardText;
      reward.hidden = !rewardText;
      if (this.promptSignature !== signature) {
        const fragment = document.createDocumentFragment();
        template.split(/(\[amount\]|\[offer\])/g).forEach(part => {
          if (part === '[amount]' || part === '[offer]') {
            const span = document.createElement('span');
            span.className = 'pr-progress__highlight';
            span.textContent = part === '[amount]' ? money : offer;
            fragment.append(span);
          } else fragment.append(document.createTextNode(part));
        });
        prompt.replaceChildren(fragment);
        this.promptSignature = signature;
      }
      prompt.hidden = !template;
    }
  }
  customElements.define('product-rewards-progress',ProductRewardsProgress);
})();
  } catch(e) { console.error(e); }
})();

})();
